// Library import
import { createRoot } from 'react-dom/client';
import { useEffect, useState } from 'react';

// Components Import
import { MultiPostForm, SinglePostForm } from '@/components';

const CreatePost = ({ locationsCsv }) => {
  const url = new URL(window.location.href);
  const [typeParam, setTypeParam] = useState(null);

  useEffect(() => {
    setTypeParam(`${url.searchParams.get('type')}`);
  }, []);

  const renderSection = () => {
    switch (typeParam) {
      case 'case_study':
        return <MultiPostForm />;

      case 'skill_support':
        return <SinglePostForm locationsCsv={locationsCsv} />;

      case 'job_hunting':
        return <SinglePostForm locationsCsv={locationsCsv} />;

      case 'news':
        return <SinglePostForm locationsCsv={locationsCsv} />;
    }
  };

  return <>{renderSection()}</>;
};

export default CreatePost;

CreatePost.prototype = {};

let element = null;

document.addEventListener('DOMContentLoaded', function (event) {
  if (!element) {
    element = document.getElementById('CreatePost');
    const root = element && createRoot(element);
    const locationsCsv = element?.dataset?.locations && JSON.parse(element.dataset.locations);
    if (element) root.render(<CreatePost locationsCsv={locationsCsv} />);
  }
});
